import {XHTTP} from '@/shared/xhttp';
import {FournisseurService} from '@/xhttp';
import {Address} from './Address';
import {Contact} from '@/models/Contact';
import {Vente} from "@/models/Vente";
import {Achat} from "@/models/Achat";

@XHTTP(FournisseurService, '/fournisseurs')
export class Fournisseur {

	private _id: number;
	private _name: string;
	private _email: string;
	private _address: string;
	private _zipCode: string;
	private _town: string;
	private _country: string;
	private _remarques: string;
	private _phone1: string;
	private _phone2: string;
	private _createdAt: Date;
	private _contacts: Contact[];
	private _achat: Achat[];

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}

	public get name(): string {
		return this._name;
	}

	public get email(): string {
		return this._email;
	}

	public get address(): string {
		return this._address;
	}

	public get zipCode(): string {
		return this._zipCode;
	}

	public get town(): string {
		return this._town;
	}

	public get country(): string {
		return this._country;
	}

	public get fullAddress(): string {
		if (this.address && this.zipCode && this.town) {
			return (this.address.trim()+' '+this.zipCode.trim()+' '+this.town.trim()).trim();
		} else if (this.address && this.zipCode && !this.town) {
			return (this.address.trim()+' '+this.zipCode.trim()).trim();
		} else if (this.address && !this.zipCode && this.town) {
			return (this.address.trim()+' '+this.town.trim()).trim();
		} else if (!this.address && this.zipCode && this.town) {
			return (this.zipCode.trim()+' '+this.town.trim()).trim();
		} else if (!this.address && !this.zipCode && this.town) {
			return this.town.trim();
		} else if (this.address && !this.zipCode && !this.town) {
			return this.address.trim();
		} else if (!this.address && this.zipCode && !this.town) {
			return this.zipCode.trim();
		} else {
			return '';
		}
	}

	public get remarques(): string {
		return this._remarques;
	}

	public get phone1(): string {
		return this._phone1;
	}

	public get phone2(): string {
		return this._phone2;
	}

	public get contacts(): Contact[] {
		return this._contacts;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	public get achat(): Achat[] {
		return this._achat;
	}

	/////////////
	// Setters //
	/////////////

	public set name(value: string) {
		this._name = value;
	}

	public set email(value: string) {
		this._email = value;
	}

	public set address(value: string) {
		this._address = value;
	}

	public set zipCode(value: string) {
		this._zipCode = value;
	}

	public set town(value: string) {
		this._town = value;
	}

	public set country(value: string) {
		this._country = value;
	}

	public set remarques(value: string) {
		this._remarques = value;
	}

	public set phone1(value: string) {
		this._phone1 = value;
	}

	public set phone2(value: string) {
		this._phone2 = value;
	}

	///////////////
	// Serialize //
	///////////////+

	public toJSON(): any {
		return {
			id       : this._id,
			name     : this._name,
			email  : this._email,
			address : this._address,
			zipCode : this._zipCode,
			town : this._town,
			country : this._country,
			remarques  : this._remarques,
			phone1   : this._phone1,
			phone2   : this._phone2,
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._name      = data.name;
		this._email   = data.email;
		this._address  = data.address;
		this._zipCode  = data.zipCode;
		this._town  = data.town;
		this._country  = data.country;
		this._remarques   = data.remarques;
		this._phone1    = data.phone1;
		this._phone2    = data.phone2;
		this._createdAt                  = data.createdAt ? new Date(data.createdAt) : null;
		this._contacts = data.contacts ? data.contacts.map(c => (new Contact()).fromJSON(c)) : null;
		this._achat = data.achat ? data.achat.map(c => (new Achat()).fromJSON(c)) : null;
		return this;
	}
}
